import { differenceInMinutes, intervalToDuration } from 'date-fns';
import { COLORS } from 'shared/constants/COLORS';
import { IAuditionSchedulesAttributes } from 'shared/interfaces/IAuditionSchedule';

export const calculateMinutesDisplay = (item: IAuditionSchedulesAttributes) => {
  const checked_in_at = item.checked_in_at ? new Date(item.checked_in_at) : new Date();
  const time_in = item.schedule?.time_in ? new Date(item.schedule?.time_in) : new Date();
  const sorted = [checked_in_at, time_in].sort((date1, date2) => new Date(date1).getTime() - new Date(date2).getTime());
  const dataObj = intervalToDuration({
    start: sorted[0],
    end: sorted[1],
  });
  if (
    (typeof dataObj.days !== 'undefined' && dataObj.days > 0) ||
    (typeof dataObj.days !== 'undefined' && dataObj.days === 0 && dataObj.hours && dataObj.hours >= 8)
  ) {
    return '8h+';
  }
  return `${dataObj.days ? `${dataObj.days}d` : ''} ${dataObj.hours ? `${dataObj.hours}h` : ''} ${
    dataObj.minutes ? `${dataObj.minutes}m` : ''
  }`;
};

export const getClockColor = (item: IAuditionSchedulesAttributes) => {
  const checked_in_at = item.checked_in_at || new Date();
  const time_in = item.schedule?.time_in || new Date();
  let clockColor = '';
  const diff = differenceInMinutes(new Date(checked_in_at), new Date(time_in));
  if (diff < 0) clockColor = COLORS.ON_TIME_COLOR;
  if (diff > 0 && diff < 31) clockColor = COLORS.LATE_SHORT_COLOR;
  if (diff > 30) clockColor = COLORS.LATE_LONG_COLOR;

  return clockColor;
};
